import React from 'react'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const StaffingIndependentTech = () => {
    const listItems = [
        "Global Payroll Management:Ensure on-time and compliant payroll processing for contractors across multiple countries.",
        "Multi-Country Compliance:Manage compliance with local labor laws, tax regulations, and statutory benefits globally.",
        "Taxation & Withholding Compliance:Handle tax calculations and withholding across diverse regions to mitigate non-compliance risks.",
        "Independent Contractor Classification:Ensure contractors are correctly classified according to local laws, minimizing the risk of misclassification.",
        "Workforce Analytics & Reporting:Gain real-time insights into your global workforce performance, helping you make informed decisions."
      ];
  return (
    <>
    <div className="wrapper">
        <div className="textcontentservice eortech">
            <h1>Tech Designed for <span>  Your Needs</span></h1>
            <p>At Ampstekpay, we combine personalized service with cutting-edge technology to streamline contractor management. Our custom-built platform simplifies onboarding, payroll, compliance, and more, giving you complete control over your global workforce in one easy-to-use interface. Whether you’re managing contractors in one country or across multiple regions, we make it seamless and compliant, so you can focus on scaling your recruitment business with confidence.</p>
            <p>By partnering with Ampstekpay, you gain access to: </p>
            <div className="listcontent">
                <ul>
                    {listItems.map((item, index) => (
                         <li key={index}><FontAwesomeIcon
                         icon={faCheckCircle} style={{
                            color: "rgb(255 102 204)", // Green color
                          }}/>&nbsp;&nbsp;&nbsp;{item}</li>
                    ))}
                </ul>
                <br/>
            </div>
            <p>Best of all, we consistently invest in our tech so that it evolves to meet the growing global needs of staffing firms.</p>
        </div>
    </div>
    </>
  )
}

export default StaffingIndependentTech